import React from 'react';
import './LegalPage.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-background" />
      
      <div className="container">
        <div className="legal-content">
          
          {/* Header */}
          <div className="legal-header">
            <div className="legal-badge">
              <div className="legal-badge-dot" />
              Legal Document
            </div>
            <h1 className="legal-title">Terms of Service</h1>
            <p className="legal-subtitle">
              Last updated: December 1, 2024
            </p>
          </div>
          
          {/* Content */}
          <div className="legal-body">
            
            <section className="legal-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using Nuroveli's cybersecurity services, you accept and agree 
                to be bound by the terms and provision of this agreement. These Terms of Service 
                apply to all visitors, users, and others who access or use our services.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>2. Description of Service</h2>
              <p>
                Nuroveli provides AI-powered cybersecurity solutions including but not limited to:
              </p>
              <ul>
                <li>Threat detection and monitoring</li>
                <li>Security analytics and reporting</li>
                <li>Incident response and alerting</li>
                <li>Custom security monitoring solutions</li>
                <li>24/7 security support services</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. User Accounts</h2>
              <h3>3.1 Account Registration</h3>
              <p>
                To access certain features, you must register for an account. You agree to provide 
                accurate, current, and complete information during registration and to update such 
                information as necessary.
              </p>
              
              <h3>3.2 Account Security</h3>
              <p>
                You are responsible for safeguarding your account credentials and for all activities 
                under your account. You must notify us immediately of any unauthorized use.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>4. Acceptable Use</h2>
              <p>You agree not to use our services to:</p>
              <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on intellectual property rights</li>
                <li>Transmit malicious code or harmful content</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with or disrupt our services</li>
                <li>Use our services for illegal or harmful purposes</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Service Availability</h2>
              <p>
                While we strive for high availability, we do not guarantee uninterrupted access 
                to our services. We may suspend or terminate services for maintenance, updates, 
                or security reasons.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>6. Data and Privacy</h2>
              <p>
                Your privacy is important to us. Our collection and use of personal information 
                is governed by our Privacy Policy, which is incorporated into these Terms by reference.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>7. Intellectual Property</h2>
              <p>
                All content, features, and functionality of our services are owned by Nuroveli 
                and are protected by international copyright, trademark, and other intellectual 
                property laws.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>8. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Nuroveli shall not be liable for any 
                indirect, incidental, special, consequential, or punitive damages arising from 
                your use of our services.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>9. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Nuroveli from any claims, damages, 
                or expenses arising from your use of our services or violation of these Terms.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>10. Termination</h2>
              <p>
                We may terminate or suspend your account and access to our services at our sole 
                discretion, without prior notice, for conduct that we believe violates these Terms 
                or is harmful to other users or our business.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>11. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify users of 
                material changes via email or through our service. Continued use after changes 
                constitutes acceptance of the new Terms.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>12. Contact Information</h2>
              <p>
                For questions about these Terms of Service, please contact us:
              </p>
              <div className="legal-contact">
                <p><strong>Email:</strong> legal@nuroveli.com</p>
                <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                <p><strong>Address:</strong> 123 Cybersecurity Avenue, Silicon Valley, CA 94043</p>
              </div>
            </section>
            
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
